/**
 * Chave de localStorage por usuário logado: preferências, filtros e seleções são da pessoa,
 * não do navegador (quem troca de login no mesmo navegador não herda o do anterior).
 */
export const userKey = (base: string): string => {
    let id = 'anon';
    try {
        const u = JSON.parse(localStorage.getItem('user') || '{}');
        id = String(u?.id ?? u?.email ?? 'anon');
    } catch { /* sem storage */ }
    return `${base}:u${id}`;
};

/** Apaga a chave antiga (sem usuário), que vazava entre logins. */
export const dropShared = (...keys: string[]) => {
    try { keys.forEach((k) => localStorage.removeItem(k)); } catch { /* sem storage */ }
};
